<section class="mt-5 px-4 d-flex align-items-center flex-column pt-5 gap-2">
  <img
    loading="lazy"
    src="assets/images/empty-state.svg"
    alt="empty-state"
    width="200"
  />
  <p class="fw-600 font-20 mb-0">{{ message }}</p>
</section>
